module.exports = __webpack_public_path__ + "assets/logo-no-text.b4cb507c.svg";